import globalLogger from "@lazarentertainment/js-logger";
import { z } from "zod";
const PubNubErrorParser = z.object({
    status: z
        .object({
        statusCode: z.number(),
        operation: z.string(),
        category: z.string(),
        errorData: z.object({
            message: z.union([
                z.string(),
                z.object({
                    code: z.string(),
                    message: z.unknown().optional(),
                    meta: z
                        .object({
                        // Only for QuotaLimitReachedError
                        refreshTime: z.number().optional(),
                    })
                        .optional(),
                }),
            ]),
        }),
    })
        .partial(),
});
export function displayNameRejectedError(displayName) {
    return {
        code: "DisplayNameRejectedError",
        displayName,
    };
}
const ChatErrorCodes = [
    "AuthenticationError",
    "DisplayNameRejectedError",
    "ProfaneMessageError",
    "QuotaLimitReachedError",
    "DeleteMessageError",
    "UnknownError",
];
export function createChatError(error) {
    var _a, _b;
    const parseResult = PubNubErrorParser.safeParse(error);
    if (!parseResult.success) {
        globalLogger.error("Couldn't parse error", error);
        return {
            code: "UnknownError",
            cause: error,
        };
    }
    const { operation, category } = parseResult.data.status;
    const message = (_a = parseResult.data.status.errorData) === null || _a === void 0 ? void 0 : _a.message;
    if (!message ||
        typeof message === "string" ||
        !isChatErrorCode(message.code)) {
        globalLogger.error("Did not recognize error message", error);
        return {
            code: "UnknownError",
            cause: error,
            operation,
            category,
        };
    }
    let chatError;
    const { code } = message;
    switch (code) {
        case "QuotaLimitReachedError": {
            chatError = quotaLimitReachedError((_b = message.meta) === null || _b === void 0 ? void 0 : _b.refreshTime);
            break;
        }
        case "DisplayNameRejectedError": {
            chatError = displayNameRejectedError(typeof message.message === "string" ? message.message : "");
            break;
        }
        case "UnknownError": {
            chatError = {
                code: "UnknownError",
                cause: error,
            };
            break;
        }
        default: {
            chatError = {
                code,
            };
        }
    }
    return Object.assign(Object.assign({}, chatError), { operation,
        category });
}
export function isChatErrorCode(code) {
    return (
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    typeof code === "string" && ChatErrorCodes.includes(code));
}
export function isChatError(error) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const maybeChatError = error;
    if ((maybeChatError === null || maybeChatError === void 0 ? void 0 : maybeChatError.code) === "QuotaLimitReachedError") {
        return typeof (maybeChatError === null || maybeChatError === void 0 ? void 0 : maybeChatError.refreshTimeMs) === "number";
    }
    return isChatErrorCode(maybeChatError === null || maybeChatError === void 0 ? void 0 : maybeChatError.code);
}
export const DEFAULT_REFRESH_TIME_MS = 30000;
export function quotaLimitReachedError(refreshTimeMs = DEFAULT_REFRESH_TIME_MS) {
    return {
        code: "QuotaLimitReachedError",
        refreshTimeMs,
    };
}
export function isQuotaLimitReachedError(error) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const maybeError = error;
    return (!!maybeError &&
        "code" in maybeError &&
        maybeError.code === "QuotaLimitReachedError" &&
        "refreshTimeMs" in maybeError &&
        typeof maybeError.refreshTimeMs === "number");
}
